// =========================================================================
// A workflow step's KPI strip — the demo's `.wfhero .stats` (line 3705).
//
// Three lines per figure: a small uppercase eyebrow, the number in mono, and
// a detail line under it. The seed already formats the value exactly as the
// demo formatted it (`toLocaleString`, `toFixed`, `fmtk`), so nothing here
// does arithmetic.
//
// It renders as a `<dl>`: these are labelled figures, and a definition list
// is what a screen reader should hear rather than four unlabelled numbers in
// a row. The eyebrow is the term and both the figure and its detail are
// descriptions of it.
//
// UI layer. Fork-owned (zone C), P5a lane.
// =========================================================================

import { cn } from '@/shared/cn';
import type { WorkflowKpi } from '@/versions/v1/shared/seed/workflow-steps';

export function WorkflowKpis({
  kpis,
  className,
}: {
  kpis: readonly WorkflowKpi[];
  className?: string;
}) {
  if (kpis.length === 0) return null;

  return (
    <dl className={cn('flex flex-wrap gap-x-[22px] gap-y-3', className)}>
      {kpis.map((kpi, i) => (
        <div key={`${kpi.eyebrow}:${i}`} className="flex min-w-0 flex-col gap-px">
          <dt
            className="text-[9.5px] font-medium uppercase tracking-[0.07em]"
            style={{ color: 'var(--ink-tertiary)' }}
          >
            {kpi.eyebrow}
          </dt>
          <dd
            className="mono text-[18px] font-semibold leading-[1.1]"
            style={{ color: 'var(--ink-primary)' }}
          >
            {kpi.value}
          </dd>
          <dd className="text-[10.5px]" style={{ color: 'var(--ink-tertiary)' }}>
            {kpi.detail}
          </dd>
        </div>
      ))}
    </dl>
  );
}
